/* eslint-disable no-inner-declarations */

import Loading from './loading.vue'
let instance = null;
let flag = false;
const vmLoading = {
  install:(Vue)=>{
    if(!instance){
        const vueLoading = Vue.extend(Loading);
        instance = new vueLoading();
        function show() {
          let vm = instance.$mount();
          if(!flag){
            document.body.appendChild(vm.$el);
            flag = true;
          }
          instance.show()
        }
        function hide() {
          instance.hide()
        }
        Vue.prototype.$vmLoading = {show,hide};
      }
    }
  }
export default vmLoading
